export default __webpack_public_path__ + "static/media/ContactCardsFields1.49a81279.png";